"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesTypeGroupSchema = void 0;
exports.ServicesTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesTypeGroup",
    "description": "ServicesTypeGroup represents one of the following types: AcastPodcast, BracketsEmbed, CartoonVideo, CloudinaryImage, EventBriteCheckout, FacebookPost, FacebookFollow, Giphy, Immersive3DModelContentful, InstagramEmbed, InstagramFollow, JotForm, MediaPartnershipsVideo, MediabaseDeliveryAgentClips, MediabaseDeliveryAgentClips, MediabaseDeliveryAgentClips, MegaphonePodcastEpisode, MixcloudAudio, ParticipantGallery, PixleeEmbed, PlatformExtension, RallyTvVideo1, RBMNAudio, RBMNLive, RBMNVideo, BrightcoveVRVideo, RedBullTVLinearStream, RedBullTVLiveVideostream, RedBullTVVideo, RiddleEmbed, RiddleEmbed, ServusTVLiveVideo, ServusTVVideo, Snapchat, SoundcloudAudio, SoundcloudAudio, SoundcloudSocialLink, Spotify, Spotify, SpotifySocialLink, SpreakerAudio, ThingImage, TickarooEmbed, TikTokEmbed, TikTokSocialLink, TwitchLiveVideo, TwitchLiveVideo, TwitchSocialLink, TwitterTweetEmbed, TwitterFollow, VimeoVideo, VKVideo, WrcErcStandingsAndResults, YoutubePlaylist, YoutubeShort, YoutubeSocialLink, YoutubeVideo, ZoeEmbed",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/acast-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/brackets-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/cartoon-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/cloudinary-image/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/eventbrite/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-socialembed-post/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/giphy-videoclip/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/immersive-3d-model-contentful/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/jotform-forms/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/media-partnerships-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/3.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/megaphone-podcast-episode/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/participant-gallery/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/pixlee-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/platform-extension/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rally-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_com-vr-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-linear-stream/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/snapchat-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spreaker-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/thing-link/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tickaroo-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-socialembed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vimeo-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/wrc-erc-standings-and-results/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-short/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/zoe-embed/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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